<template>
  <Button width="full" theme="primary" @click="toggleWishList">
    {{ label }}
  </Button>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import Button from "@/components/ButtonV3.vue";

export default {
  name: "WishlistButton",
  components: {
    Button,
  },
  inject: ["mq"],
  props: {
    product: {
      type: Object,
      required: true,
    },
    variant: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      action: "add",
    };
  },
  computed: {
    ...mapState("auth", ["customer"]),
    ...mapGetters("auth", ["isLoggedIn", "wishlist"]),
    strippedProductVariantId() {
      return this.variant?.id.split("gid://shopify/ProductVariant/")[1];
    },
    label() {
      return this.action === "add" ? "ADD TO WISHLIST" : "REMOVE FROM WISHLIST";
    },
  },
  watch: {
    wishlist() {
      this.checkIfProductVariantInWishlist();
    },
    variant() {
      this.checkIfProductVariantInWishlist();
    },
  },
  mounted() {
    this.checkIfProductVariantInWishlist();
  },
  methods: {
    ...mapActions("app", ["setWishlistLoginOpenState", "addItemToWishlist"]),
    async toggleWishList() {
      if (!this.isLoggedIn) {
        this.addProductToGuestWishlist();
        this.setWishlistLoginOpenState(true);
        return;
      }

      const oldAction = this.action;
      this.action = oldAction === "add" ? "remove" : "add";

      await this.addItemToWishlist({
        productVariantId: this.variant.id,
        action: oldAction.toLowerCase(),
        product: this.product,
      });

      this.checkIfProductVariantInWishlist();
    },
    addProductToGuestWishlist() {
      localStorage.setItem(
        "ratandboaGuestWishlist",
        this.strippedProductVariantId
      );
    },
    checkIfProductVariantInWishlist() {
      if (!this.isLoggedIn) {
        return false;
      }

      const localWishlist = localStorage.getItem("ratandboaWishlist");

      if (localWishlist) {
        const wishlists = JSON.parse(localStorage.getItem("ratandboaWishlist"));
        const wishlist = wishlists[0];
        const inWishlist = wishlist.productVariants.includes(
          this.strippedProductVariantId
        );
        this.action = inWishlist ? "remove" : "add";
      } else {
        this.action = "add";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  background-color: $color-grey-light;
  color: $color-black;
  border: none;
}
</style>
